import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="volumes" className="w-full scroll-mt-16 bg-sand py-10 sm:py-14" aria-labelledby="volumes-heading" data-id="element-201" data-mp="cm526r4zghlj">
      <div className="mx-auto max-w-4xl px-6" data-id="element-202" data-mp="3g57u1u9g1p5k">
        <SectionHeading eyebrow="📚 The core 6-volume library" title={<span id="volumes-heading" data-id="element-204" data-mp="3c4627yhuwfdm">150 lessons. Zero planning.</span>} lead="Six volumes covering every level and every part of your session. Open any volume to see the problem it solves and what’s inside." data-id="element-203" data-mp="3g60yupoue4l2" />

        <ol className="mt-8 space-y-2.5" data-id="element-205" data-mp="3l42jvg5twdz6">
          {volumes.map((volume, index) => {
          const isOpen = openIndex === index;
          return <li key={volume.code} className={`rounded-3xl border bg-shell transition-colors duration-150 ease-out ${isOpen ? 'border-navy/40' : 'border-line'}`} data-id="element-206" data-mp="2xcx5z6jg7vri" data-mpi={index}>
                <h3 data-id="element-207" data-mp="29ga63sfjbhpr">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-center gap-4 rounded-3xl px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy sm:px-6" data-id="element-208" data-mp="29ez683p7mu3x">
                    <span className="inline-flex h-11 w-11 shrink-0 flex-col items-center justify-center rounded-xl bg-navy-deep font-display text-sm font-extrabold text-lime" aria-hidden="true" data-id="element-209" data-mp="1qgmldkoxrvsi">
                      {volume.code}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-210" data-mp="20d95265j0gsy">
                      <span className="block font-display text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-211" data-mp="24gxbummc38d5">
                        {volume.name}
                        <span className="font-medium text-stone" data-id="element-212" data-mp="3btpo09gahfkk">
                          {' '}
                          — {volume.subtitle}
                        </span>
                      </span>
                      <span className="mt-0.5 block font-sans text-xs font-semibold uppercase tracking-[0.12em] text-navy" data-id="element-213" data-mp="1gozsnmtyrru3">
                        {volume.count}
                      </span>
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-stone transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-214" data-mp="1pp4u7gch7w0c" />
                  </button>
                </h3>

                <div id={`volume-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-215" data-mp="t1i1ntiiwxs6">
                  <div className="overflow-hidden" data-id="element-216" data-mp="121em1ixvrahf">
                    <div className="border-t border-line px-5 py-5 sm:px-6" data-id="element-217" data-mp="120llizpilh7q">
                      <p className="font-sans text-[0.9rem] leading-relaxed text-stone" data-id="element-218" data-mp="eb11seljefxe">
                        <span className="font-semibold text-ink" data-id="element-219" data-mp="9c7n4iuikivn">
                          The problem solved:{' '}
                        </span>
                        {volume.intro}
                      </p>
                      <ul className="mt-5 space-y-3" data-id="element-220" data-mp="2psvyb75svff9">
                        {volume.focus.map(item => <li key={item.title} className="border-l-2 border-lime pl-4 font-sans text-[0.85rem] leading-relaxed" data-id="element-221" data-mp="2c0z7d6fvbbkg">
                            <span className="block font-semibold text-ink" data-id="element-222" data-mp="2gz93pkdbwi7n">
                              {item.title}
                            </span>
                            <span className="block text-stone" data-id="element-223" data-mp="38qgnkfch8g0e">
                              {item.detail}
                            </span>
                          </li>)}
                      </ul>
                      <p className="mt-5 border-t border-line pt-4 font-display text-[0.95rem] font-bold leading-snug text-navy" data-id="element-224" data-mp="2zopj1dtoaf84">
                        {volume.result}
                      </p>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}